import { A, useNavigate, useParams } from '@solidjs/router'
import { createMemo, For, Show } from 'solid-js'
import { getAssetUrl } from '/web/shared/util'
import { chatStore, settingStore } from '/web/store'
import { getModelUrl } from '/web/shared/aifans/lib/model-util'

const ChatRightNav = () => {
  const params = useParams()
  const nav = useNavigate()

  const chats = chatStore((s) => ({
    ...(s.active?.chat._id === params.id ? s.active : undefined),
  }))

  const traits = createMemo(() => [
    { label: 'Personality', value: chats.char?.personality },
    { label: 'Occupation', value: chats.char?.occupation },
    { label: 'Hobbies', value: chats.char?.hobbies },
    { label: 'Relationship', value: chats.char?.relationship },
    { label: 'Body', value: chats.char?.bodyType },
    { label: 'Breasts', value: chats.char?.breasts },
    { label: 'Butt', value: chats.char?.butt },
    { label: 'Age', value: chats.char?.age },
    { label: 'Hair', value: chats.char?.hair },
    { label: 'Ethnicity', value: chats.char?.ethnicity },
  ].filter(t => t.value))

  return (
    <>
      {/* Image — rounded, inside the 20px padding */}
      <div class="mb-3.5 overflow-hidden rounded-[14px]" style={{ 'aspect-ratio': '4/5' }}>
        {chats.char?.avatar && (
          <img
            class="h-full w-full object-cover"
            src={getAssetUrl(chats.char?.avatar, true, { width: 640 })}
            alt={chats.char?.name}
          />
        )}
      </div>

      {/* Name + model + generate */}
      <div class="mb-[18px] text-center">
        <div class="font-bebas text-[24px] tracking-[1px] text-white">{chats.char?.name}</div>
        <div class="mb-3.5 font-rajdhani text-[12px] text-[var(--cf-cyan)]">
          Model — {chats.char?.realName}
        </div>
        <button
          onClick={() => nav(`/generate-image/${chats.char?._id}`)}
          class="block h-[44px] w-full rounded-full font-rajdhani text-[12px] font-extrabold uppercase tracking-[0.8px] text-white transition-all hover:-translate-y-px"
          style={{
            background: 'var(--cf-grad-hot)',
            'box-shadow': '0 4px 14px rgba(138,43,226,0.3)',
          }}
        >
          Generate Image
        </button>
      </div>

      {/* Divider */}
      <div class="mb-[18px] mt-2 h-px bg-[var(--cf-hairline)]" />

      {/* About Me + View Profile */}
      <div class="mb-3 flex items-center justify-between">
        <span class="font-rajdhani text-[12px] font-bold uppercase tracking-[1.4px]">About Me</span>
        <A
          href={getModelUrl(chats.char?.categorySlug, chats.char?.slug || chats.char?._id)}
          class="font-rajdhani text-[11px] text-[var(--cf-cyan)] hover:text-white"
        >
          View {chats.char?.realName}'s Profile →
        </A>
      </div>

      {/* Traits grid — reactive */}
      <div class="grid grid-cols-2 gap-2">
        <For each={traits()}>
          {(t) => (
            <div
              class="rounded-[10px] border border-[var(--cf-hairline)] px-3 py-2.5"
              style={{ background: 'rgba(255,255,255,0.03)' }}
            >
              <div class="font-rajdhani text-[9px] font-bold uppercase tracking-[1px] text-[var(--cf-muted)]">
                {t.label}
              </div>
              <div class="mt-0.5 font-rajdhani text-[13px] font-bold text-white">{t.value}</div>
            </div>
          )}
        </For>
      </div>
    </>
  )
}

export default ChatRightNav
